import { MobileDateRangePicker } from '@eventr/common-storybook'
import { Control, Controller, useFormContext } from 'react-hook-form'
import {
    editItineraryTranslation,
    generalTranslation,
} from '../../../i18n/translateHelpers'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { bs, useBoundStore } from '../../../state/bound.store'
import { useShallow } from 'zustand/react/shallow'

interface IFormDateRangeProps {
    control: Control
    startName: string
    endName: string
    required?: boolean
    fieldLabel?: string
}
export const FormDateRange = ({
    startName,
    endName,
    control,
    required,
    fieldLabel,
}: IFormDateRangeProps) => {
    const { getLanguageISO639Code } = useLanguageContext()
    const { setValue, getValues, watch } = useFormContext()
    const { selectedSection } = useBoundStore(
        useShallow((s) => {
            return {
                selectedSection: s.selectedSection,
            }
        })
    )
    const endValue = watch(endName)

    const onSave = (startDate: string, endDate: string) => {
        setValue(startName, startDate, {
            shouldDirty: true,
            shouldTouch: true,
        })
        setValue(endName, endDate, {
            shouldDirty: true,
            shouldTouch: true,
        })
    }
    const handleClear = () => {
        setValue(startName, '', {
            shouldDirty: true,
            shouldTouch: true,
        })
        setValue(endName, '', {
            shouldDirty: true,
            shouldTouch: true,
        })
    }

    return (
        <Controller
            name={startName}
            control={control}
            render={({ field: { value }, fieldState: { error } }) => {
                return (
                    <MobileDateRangePicker
                        fieldLabel={fieldLabel}
                        openTo={
                            value
                                ? value
                                : selectedSection === 1
                                ? undefined
                                : bs().getEventInfoV2()?.data.start_date
                        }
                        startDateTimeString={value}
                        endDateTimeString={endValue}
                        onSave={onSave}
                        onClear={handleClear}
                        language={getLanguageISO639Code()}
                        translationString={{
                            saveButton: generalTranslation('done'),
                            select: editItineraryTranslation(
                                'select-date',
                                'fields'
                            ),
                        }}
                        isError={error !== undefined}
                        textError={error?.message}
                        required={required}
                    />
                )
            }}
        />
    )
}
